<template>
    <div>
        <v-toolbar flat dark color="primary" class="map-toolbar" :class="{'is-inverted' : mapType != 'roadmap'}">
            <v-btn icon @click="gotoDevice()">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>
                {{ device ? device.name : '' | capitalize }}
                <span class="v-toolbar__subtitle" v-if="device">

                    <span v-if="device.getState().accuracy < 20">Je E-finder bevond zich hier </span>
                    <span v-else>Je E-finder bevond zich in de cirkel </span>

                    <span v-if="device.isMoving()"> en was in beweging</span>
                    <span v-else> en stond stil</span>
                </span>

            </v-toolbar-title>
            <v-btn icon @click="showMenu()">
                <v-icon>menu</v-icon>
            </v-btn>
        </v-toolbar>

        <uf-drawer :offset="0" class="e-connectz_drawer-history" :class="{'is-inverted' : mapType != 'roadmap'}">

            <v-layout slot="above" justify-space-between>
                <uf-value label="precisie" type="m">
                    {{ device.getState().accuracy }}
                </uf-value>
                <v-btn absolute fab right style="bottom: 100%" class="mb-4" @click="toggleMapType">
                    <v-icon>{{ mapType === 'roadmap' ? 'satellite' : 'map' }}</v-icon>
                </v-btn>
                <uf-value label="datum en tijd">
                    {{ device.getLastFormattedUpdate('D MMM HH:mm') }}
                </uf-value>
                <uf-value label="batterij" type="%">
                    {{ device.getState().battery_percentage }}
                </uf-value>
            </v-layout>

            <v-card-title slot="top" class="e-connectz_card-title">

                <v-layout justify-center align-center class="history_nav mt-1 mb-3">

                    <v-btn icon dark color="#989885" @click="backward(1500)" class="mr-1"
                           :disabled="device.stateIndex === device.states.length -1">
                        <v-icon small color="#FDFDE7">fast_rewind</v-icon>
                    </v-btn>
                    <v-btn icon dark color="#989885" @click="prevState(1)" large class="mr-1"
                           :disabled="device.stateIndex === device.states.length -1">
                        <v-icon color="#FDFDE7" large>chevron_left</v-icon>
                    </v-btn>
                    <v-btn icon dark color="#989885" @click="nextState(1)" large class="mr-1"
                           :disabled="device.stateIndex === 0">
                        <v-icon color="#FDFDE7" large>chevron_right</v-icon>
                    </v-btn>
                    <v-btn icon dark color="#989885" @click="forward(1500)" :disabled="device.stateIndex === 0">
                        <v-icon small color="#FDFDE7">fast_forward</v-icon>
                    </v-btn>

                    <v-btn icon outline color="#989885" class="btn-close mb-2" @click="gotoDevice()" small>
                        <v-icon small color="#989885">close</v-icon>
                    </v-btn>
                </v-layout>

                <div class="e-connectz_card-title_above-footer">
                    Bron: {{ device.getStateMessageType() }}
                </div>

                <div class="e-connectz_card-title_footer">
                    Geschiedenis mode actief
                </div>

            </v-card-title>

        </uf-drawer>
    </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      stateIndex: 0,
      timeToShow: moment(),
    };
  },
  watch: {
    timeToShow(value) {
      // this.$store.dispatch('setStateOfDeviceByDate', value);
    },
  },
  computed: {
    device() {
      return this.$store.getters.device;
    },
    mapType() {
      return this.$store.state.map.mapTypeId;
    },
  },
  methods: {
    showMenu() {
      this.$store.dispatch('openMainMenu');
    },
    gotoDevice() {
      this.$router.push({name: 'devices.show', params: {id: this.device.id}});
    },
    prevState(speed = 1) {
      this.$store.dispatch('prevStateOfDevice', speed);
    },
    nextState(speed = 1) {
      this.$store.dispatch('nextStateOfDevice', speed);
    },
    backward(minutes = 5) {
      const time = moment(this.device.getLastUpdate().subtract(minutes, 'minutes'));
      this.$store.dispatch('setStateOfDeviceByDate', time);
    },
    forward(minutes = 5) {
      const time = moment(this.device.getLastUpdate().add(minutes, 'minutes'));
      this.$store.dispatch('setStateOfDeviceByDate', time);
    },
    toggleMapType() {
      this.$store.dispatch('toggleMapType');
    },
  },
  mounted() {
    this.$store.dispatch('enableHistoryMode', 0);
  },
};
</script>

<style lang="stylus">
    .e-connectz_card-title {
        position: relative
        display: block
        &:before {
            content: ''
            display: block
            position: absolute
            left: 0
            right: 0
            bottom: 0
            height: 16px
            background-image: linear-gradient(to top, rgba(#455B63, .075), rgba(#455B63, 0))
        }

        .v-btn {
            margin-top: 0
            &.btn-close {
                position: absolute
                right: 24px
                margin-top: -2px
                &:after {
                    content: ''
                    position: absolute
                    top: 0
                    right: 0
                    bottom: 0
                    left: 0
                    border-radius: 50%
                    border: solid 1px #989885
                }

            }
        }

        h3 {
            font-size: 1.5rem
            font-weight: normal
        }

        p {
            margin: 0
            color: rgba(#17263C, .55)
        }
    }

    .uf-drawer.e-connectz_drawer-history {
        .v-card {
            background-color: #FDFDE7
        }

        .uf-drawer-toggle {
            display: none
        }

        .e-connectz_card-title {
            padding-bottom: 0
        }

        .v-btn {
            color: #989885
        }
        .v-btn.v-btn--disabled {
            opacity: .25
        }

        .e-connectz_card-title_above-footer {
            position: absolute
            background-color: #FDFDE7
            color: #989885
            margin: 0 -16px
            padding: .25rem
            transform: translateY(-100%)
        }

        .e-connectz_card-title_footer {
            position: relative
            display: block
            width: auto
            content: 'Geschiedenis mode actief'
            background-color: #989885
            color: #FDFDE7
            text-align center
            margin: 0 -16px
            padding: .25rem
        }

    }
</style>
